
import React, { useEffect, useMemo, useState } from 'react';

const LinearFitAnimation = ({ isActive }) => {
  const points = useMemo(
    () => [
      { x: 20, y: 82 },
      { x: 30, y: 50 },
      { x: 45, y: 50 },
      { x: 65, y: 45 },
      { x: 85, y: 25 },
    ],
    []
  );

  const lines = useMemo(
    () => [
      { m: 0, b: 55 },
      { m: -0.7, b: 90 },
      { m: -0.5, b: 80 },
    ],
    []
  );

  const lineEndpoints = useMemo(
    () =>
      lines.map(({ m, b }) => ({
        x1: 10,
        y1: m * 10 + b,
        x2: 92,
        y2: m * 90 + b,
      })),
    [lines]
  );

  const residuals = useMemo(
    () =>
      lines.map(({ m, b }) =>
        points.map((p) => ({
          x: p.x,
          y1: p.y-2,
          y2: m * p.x + b,
        }))
      ),
    [lines, points]
  );

  const totalSteps = 4;
  const [step, setStep] = useState(0);

  useEffect(() => {
    if (!isActive) {
      setStep(0);
      return;
    }
    const id = setInterval(() => {
      setStep((s) => (s + 1) % totalSteps);
    }, 1500);
    return () => clearInterval(id);
  }, [totalSteps, isActive]);

  return (
    <div className="rounded-lg overflow-hidden">
      <svg
        viewBox="0 0 100 100"
        width="100%"
        height="100%"
        style={{ backgroundColor: '#eab308' }}
        xmlns="http://www.w3.org/2000/svg"
      >
        <line x1="10" y1="10" x2="10" y2="90" stroke="#f3f4f6" strokeWidth="4" />
        <line x1="8.0" y1="90" x2="90" y2="90" stroke="#f3f4f6" strokeWidth="4" />

        {points.map((p, idx) => (
          <circle key={idx} cx={p.x} cy={p.y} r="3" fill="#f3f4f6" />
        ))}

        {lineEndpoints.map((line, idx) => (
          <g
            key={idx}
            style={{
              opacity: step === idx + 1 ? 1 : step > idx + 1 ? 0.4 : 0,
              transition: 'opacity 0.4s',
            }}
          >
            <line
              x1={line.x1}
              y1={line.y1+5}
              x2={line.x2}
              y2={line.y2+5}
              stroke="#f3f4f6"
              strokeWidth="4"
            />
            {step === idx + 1 &&
              residuals[idx].map((r, i) => (
                <line
                  key={i}
                  x1={r.x}
                  y1={r.y1+5}
                  x2={r.x}
                  y2={r.y2+5}
                  stroke="#f3f4f6"
                  strokeWidth="2"
                  strokeDasharray="3"
                />
              ))}
          </g>
        ))}
      </svg>
    </div>
  );
};

export default LinearFitAnimation;

